"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayComponent = exports.DisplayWrapper = void 0;
const react_1 = __importDefault(require("react"));
const DisplayWrapper = ({ content }) => {
    if (typeof content === "object" && (!(content === null || content === void 0 ? void 0 : content.type) || !content.props)) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return react_1.default.createElement(react_1.default.Fragment, null, content);
};
exports.DisplayWrapper = DisplayWrapper;
const defaultConverter = (value) => value;
const DisplayComponent = (displayName, converter) => {
    const DisplayComponent = ({ value, schema, }) => {
        return (react_1.default.createElement(exports.DisplayWrapper, { content: (converter || defaultConverter)(value, schema) }));
    };
    DisplayComponent.displayName = displayName;
    return DisplayComponent;
};
exports.DisplayComponent = DisplayComponent;
